import React, { Component } from 'react';
import clone from 'clone';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';
import axios from 'axios';
import AdPreview from '../../components/AdPreview';
import { dataList } from '../Tables/antTables';
import * as rechartConfigs from '../Charts/recharts/config';
import ContentHolder from '../../components/utility/contentHolder';
import Tooltip from '../../components/uielements/tooltip';
import  SimpleDonutChart  from '../../containers/Charts/reactVis/charts/simpleDonutChart';
import Box from '../../components/utility/box';
import * as configs from '../../containers/Charts/reactVis/config';
import {Line} from 'react-chartjs-2';
import basicStyle from '../../config/basicStyle';
import IsoWidgetsWrapper from './widgets-wrapper';
import IsoWidgetBox from './widget-box';
import SaleWidget from './sale/sale-widget';
import { DashboardWrapper } from './style.js';
import appsflyer from '../../image/roi/apps_flyer.png';
import adjust from '../../image/roi/adjust.jpg';
import tune from '../../image/roi/tune.png';
import kochava from '../../image/roi/Kochava.png';
import RunningIcon from '../../image/running.png';
import PauseIcon from '../../image/pause.png';
import RefreshIcon from '../../image/refresh.png';
import CalendarIcon from '../../image/calendar.png';
import DownloadIcon from '../../image/download.png';
import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import 'rc-tabs/assets/index.css';
import appActions from '../../redux/app/actions';
const { appSelected, searchTermUpdated } = appActions;
import { bindActionCreators } from 'redux'
import { DateRangePicker } from '../../components/uielements/reactDates';
import moment, { calendarFormat } from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Flag from 'react-world-flags'
import Dropdown, {
  // DropdownButtons,
  DropdownMenu,
  MenuItem,
  SubMenu
} from '../../components/uielements/dropdown';
import Modal from 'react-responsive-modal';
import ButtonAction from '../../components/ButtonAction';

// -- Components
import AddBudgetModal from "./AddBudgetModal/index";
import CircularProgressBar from "../../components/CircularProgressBar/index";
import OverlayLoading from "../../components/OverlayLoading/index";

import API_URL from './../../constants/server';
import NProgress from 'nprogress';

import { StripeProvider, Elements } from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm';
import STRIPE_PUBLISHABLE from './../../constants/stripe';
import PAYMENT_SERVER_URL from './../../constants/server';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import ReactExport from "react-data-export";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const tableDataList = clone(dataList);
tableDataList.size = 5;

const data1 = {
  labels: [
    'Red',
    'Green',
    // 'Yellow'
  ],
  datasets: [{
    data: [300, 50, ],
    backgroundColor: [
    '#FF6384',
    '#36A2EB',
    // '#FFCE56'
    ],
    hoverBackgroundColor: [
    '#FF6384',
    '#36A2EB',
    // '#FFCE56'
    ]
  }]
};

const downLoadsData = {
  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
  datasets: [
    {
      label: 'Downloads',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(71, 214, 204, 1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(71, 214, 204, 1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(71, 214, 204, 1)',
      pointHoverBorderColor: 'rgba(71, 214, 204, 1)',
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 5,
      data: [231, 31, 84, 73, 46, 117, 279]
    }
  ]
};

const cpaData = {
  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
  datasets: [
    {
      label: 'CPA',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(93, 215, 255, 1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(93, 215, 255, 1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(93, 215, 255, 1)',
      pointHoverBorderColor: 'rgba(93, 215, 255, 1)',
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 5,
      data: [0.93, 0.86, 0.71, 1.29, 0.68, 0.79, 0.78, 0.86]
    }
  ]
};

const budgetSpendData = {
  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
  datasets: [
    {
      label: 'Budget Spent',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(236, 184, 92, 1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(236, 184, 92, 1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(236, 184, 92, 1)',
      pointHoverBorderColor: 'rgba(236, 184, 92, 1)',
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 5,
      data: [214.83, 26.66, 59.64, 94.17, 31.28, 92.43, 217.62, 736.63]
    }
  ]
};

const conversionRateData = {
  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
  datasets: [
    {
      label: 'Conversion Rate',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(114, 90, 166, 1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(114, 90, 166, 1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(114, 90, 166, 1)',
      pointHoverBorderColor: 'rgba(114, 90, 166, 1)',
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 5,
      data: [76.74, 72.09, 75.00, 82.95, 70.77, 79.59, 81.58, 78.42]
    }
  ]
};



class Dashboard extends Component {

  constructor(props){
    super(props)

    moment.locale('zh-cn');

    this.state = { 
      startDate: null,
      endDate: null,
      isShowBudgetModal: false,    
      isShowCheckoutModal: false,
      storeInfo: null,
      searchAdsInfo: null,
      appRecord: null, //storing cid in each region
      currentRegion: null,
      isReportLoading: false,
      stripe: null,
      addBudgetData: null,
      isCampaignRunning: false
    }
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.goToAso = this.goToAso.bind(this);
    this.onRegionSelected = this.onRegionSelected.bind(this);
    this.getCampaignReportingData = this.getCampaignReportingData.bind(this);
    this.getCampaignMetaData = this.getCampaignMetaData.bind(this);
    this.updateReport = this.updateReport.bind(this);
    this.onBudgetComfirmed = this.onBudgetComfirmed.bind(this);
  }

  onRegionSelected = (item) => {
    console.log( 'on region selected : ', item);

    if ( item.key === 'ALL'){
      /**
       * not yet handled
       */
    } else if ( this.state.appRecord) {
      const appRecord = this.state.appRecord;
      const region = item.key;
      const pIndex = appRecord.performanceByRegion.findIndex( item => {
        return item.region === region;
      })
      const dIndex = appRecord.discoveryByRegion.findIndex( item => {
        return item.region === region;
      })
      this.setState({
        currentRegion: {
          region: region,
          pCid: appRecord.performanceByRegion[pIndex].campaignId,
          dCid: appRecord.discoveryByRegion[dIndex].campaignId
        }
      });
    }
  }
  onDatesChange({ startDate, endDate }) {
    console.log( 'ondates change : ',startDate , endDate)
    this.setState({ startDate, endDate });

    // console.log( moment(startDate).format('YYYY-MM-DD'))
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  handleAddCampClick = ( event ) => {
    this.props.history.push(`${'/campaign/list'}`);

  }

  goToAso = (event) => {
    const { match: { params } } = this.props;
    this.props.history.push(`/aso/${params.appId}`);
  }

  changeCampaignState = async (isSwitchingOn) => {
    let Status = isSwitchingOn ? "ENABLED" : "PAUSED";
    this.setState({isCampaignRunning: isSwitchingOn});

    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    const request = {
        campaign: {
            status: Status,
        }
        // Whether user intends to run this campaign/adgroup or not. ENABLED, PAUSED
    };

    const CampaignIDs = [this.state.currentRegion.pCid, this.state.currentRegion.dCid];
    await Promise.all(CampaignIDs.map( async (cid) => {
        let requestResponse;
        try {
            requestResponse = await axios.post(`${API_URL}/user/campaigns/cid/${cid}`, request, { headers } );
            
            const updatedCampaign = requestResponse.data.response.data;
            console.log( '[Dashboard][changeCampaignState] ', cid,  updatedCampaign);
        } catch (error) {
            console.error('[Dashboard][changeCampaignState] ', cid, error);
        }
    }));
    this.updateResult(true, null);
  };

  onBudgetComfirmed = (budget, region) => {
    if ( process.env.REACT_APP_STAGE !== 'fake' ){

      const { appRecord } = this.state;

      // const dIndex = appRecord.discoveryByRegion.findIndex(item => item.region === region);
      // const pIndex = appRecord.performanceByRegion.findIndex(item => item.region === region);
      // const dCid = appRecord.discoveryByRegion[dIndex].campaignId;
      // const pCid = appRecord.discoveryByRegion[dIndex].campaignId;

      console.log( budget , region)
      const { match: { params } } = this.props;
      this.setState({
        addBudgetData: {
          budget,
          region,
          appId: params.appId
        }
      })
      this.onCloseAddBudgetModal();
      this.onOpenCheckoutModal();
    }
  }

  updateResult = async( success, text) => {
    if ( success){
      this.onCloseCheckoutModal();
    
      const { currentRegion, startDate, endDate } = this.state;

      NProgress.start();

      this.setState({ isReportLoading : true});
      const pRowReporting = await this.getCampaignReportingData(currentRegion.pCid, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')); 
      const dRowReporting = await this.getCampaignReportingData(currentRegion.dCid, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')); 
      const pData = await this.getCampaignMetaData(currentRegion.pCid);
      const dData = await this.getCampaignMetaData(currentRegion.dCid);
      NProgress.done();
      this.setState({ isReportLoading : false});

      console.log( pData, dData, pRowReporting, dRowReporting);
      this.updateReport(pData, dData, pRowReporting, dRowReporting);

    }
  }

  updateError = ( err ) => {
    
  }

  onOpenAddBudgetModal = () => { this.setState({isShowBudgetModal: true}); };
  onCloseAddBudgetModal = () => { this.setState({isShowBudgetModal: false}); };
  onOpenCheckoutModal = () => { this.setState({isShowCheckoutModal: true}); };
  onCloseCheckoutModal = () => { this.setState({isShowCheckoutModal: false}); };

  async componentDidMount(){
    const { match: { params } } = this.props;

    const storeInfo = await this.getItunesStoreData(params.appId); 
    const searchAdsInfo = await this.getSearchAdsData(params.appId);
    console.log( 'searchAdsInfo : ', searchAdsInfo); //appId complu

    this.setState({storeInfo, searchAdsInfo, appId : params.appId});
    console.log( 'params : ', params); //appId complu
    //dcid pcid // region
    // itunesAppInfo
    if ( process.env.REACT_APP_STAGE !== 'fake' ){
      const appRecord = await this.getAppRecord(params.appId); 
      let currentRegion;
      if ( !params.dcid || !params.pcid || !params.region){

        const region = appRecord.performanceByRegion[0].region;
        const pCid  =  appRecord.performanceByRegion[0].campaignId;
        /**
         * dIndex must be > -1 due to current camapgin creation mehcnaism 
         */
        const dIndex = appRecord.discoveryByRegion.findIndex( item => {
          return item.region === region;
        })
        currentRegion = {
          region: region,
          pCid: pCid,
          dCid: appRecord.discoveryByRegion[dIndex].campaignId
        };
      } else {
        currentRegion = {
          region: params.region,
          pCid: params.pcid,
          dCid: params.dcid
        };
      }
      this.setState({appRecord, currentRegion});
    }

    //load stripe
    if (window.Stripe) {
      this.setState({stripe: window.Stripe(STRIPE_PUBLISHABLE)});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({stripe: window.Stripe(STRIPE_PUBLISHABLE)});
      });
    }

    //load profile
    this.setState({ profile: {} });
    const { userProfile, getProfile } = this.props.auth;
    if (!userProfile) {
      getProfile((err, profile) => {
        this.setState({ profile });
      });
    } else {
      this.setState({ profile: userProfile });
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    const { currentRegion, startDate, endDate } = this.state;
    if ( currentRegion){
      if ( !prevState.currentRegion || currentRegion.region !== prevState.currentRegion.region){
        /**
         * change in currenEregion
         */
        let endDate = moment();//.format('YYYY-MM-DD');      
        let startDate = moment(endDate).subtract(20, 'days');
        this.setState({startDate, endDate});
      
        
      }
    }

    if ((startDate && endDate && startDate !== prevState.startDate) || (startDate && endDate && endDate !== prevState.endDate)){
      console.log( startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
      NProgress.start();

      this.setState({ isReportLoading : true});
      const pRowReporting = await this.getCampaignReportingData(currentRegion.pCid, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')); 
      const dRowReporting = await this.getCampaignReportingData(currentRegion.dCid, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')); 
      const pData = await this.getCampaignMetaData(currentRegion.pCid);
      const dData = await this.getCampaignMetaData(currentRegion.dCid);
      NProgress.done();
      this.setState({ isReportLoading : false});

      console.log( 'asdfasd', pData, dData, pRowReporting, dRowReporting);
      this.updateReport(pData, dData, pRowReporting, dRowReporting);

    }
    
  }

  updateReport = (pData, dData, pReporting,  dReporting)=>{
    console.log( dData, pData,pReporting)
     /*
    avgCPA:{amount: "0.6667", currency: "USD"}
avgCPT:{amount: "0.3333", currency: "USD"}
conversionRate:0.5
conversions:1
conversionsLATOff:1
conversionsLATOn:0
conversionsNewDownloads:0
conversionsRedownloads:1
date:"2018-06-09"
impressions:6
localSpend:{amount: "0.6667", currency: "USD"}
taps:2
ttr:0.3333*/
/*
{id: 156549698, 
  orgId: 379480, 
  name: "DEV-B13IAQFlQ-331177714-GB-D",
   budgetAmount: {…}, 
   dailyBudgetAmount: null, …}
   adGroups: (2) [{…}, {…}]
   adamId: 331177714
   additionalDetail: null
   budgetAmount: {amount: "0.6666666667", currency: "USD"}
   budgetOrders: []dailyBudgetAmount: null
   deleted: falsedis
   playStatus: "ON_HOLD"
   endTime: null
   id: 156549698
   locInvoiceDetails: null
   modificationTime: "2018-06-18T04:22:07.750"
   name: "DEV-B13IAQFlQ-331177714-GB-D"
   negativeKeywords: []
   orgId: 379480
   paymentModel: "PAYG"
   referenceLabel: null
   servingStateReasons: ["TOTAL_BUDGET_EXHAUSTED"]
   servingStatus: "NOT_RUNNING"
   startTime: "2018-06-09T10:48:36.120"
   status: "ENABLED"
   storefront: "GB"
*/

    const totalSpent = pReporting.totalData ? parseFloat(pReporting.totalData.localSpend.amount) + parseFloat(dReporting.totalData.localSpend.amount) : 0;
    const totalNewDownloads = pReporting.totalData ? parseFloat(pReporting.totalData.conversionsNewDownloads) + parseFloat(dReporting.totalData.conversionsNewDownloads) :0 ;
    const totalReDownloads = pReporting.totalData ? parseFloat(pReporting.totalData.conversionsRedownloads) + parseFloat(dReporting.totalData.conversionsRedownloads) : 0;
    const avgCPA = pReporting.totalData ?( parseFloat(pReporting.totalData.avgCPA.amount) + parseFloat(dReporting.totalData.avgCPA.amount) ) / 2.0 : 0 ;
    const conversionRate = pReporting.totalData ? ( parseFloat(pReporting.totalData.conversionRate) + parseFloat(dReporting.totalData.conversionRate) ) / 2.0 :0;
    const ttr = pReporting.totalData ? ( parseFloat(pReporting.totalData.ttr) + parseFloat(dReporting.totalData.ttr) ) / 2.0  : 0;
    const labels = pReporting.granularity.map( item => moment(item.date).format('MM/DD'));
    const budgetLeft = (parseFloat(pData.budgetAmount.amount) + parseFloat(dData.budgetAmount.amount) - totalSpent).toFixed(2);
    const cpaData = {
      labels: labels, //['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
      datasets: [
        {
          label: 'CPA',
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(93, 215, 255, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(93, 215, 255, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(93, 215, 255, 1)',
          pointHoverBorderColor: 'rgba(93, 215, 255, 1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 5,
          data: pReporting.granularity.map( item => parseFloat(item.avgCPA.amount))
        }
      ]
    };
    const downLoadsData = {
      labels: labels,
      datasets: [
        {
          label: 'Downloads',
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(71, 214, 204, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(71, 214, 204, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(71, 214, 204, 1)',
          pointHoverBorderColor: 'rgba(71, 214, 204, 1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 5,
          data: pReporting.granularity.map( item => item.conversionsNewDownloads + item.conversionsRedownloads)
        }
      ]
    };
    const budgetSpendData = {
      labels: labels,
      datasets: [
        {
          label: 'Budget Spent',
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(236, 184, 92, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(236, 184, 92, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(236, 184, 92, 1)',
          pointHoverBorderColor: 'rgba(236, 184, 92, 1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 5,
          data: pReporting.granularity.map( item => parseFloat(item.localSpend.amount))
        }
      ]
    };
    
    const conversionRateData = {
      labels: labels,
      datasets: [
        {
          label: 'Conversion Rate',
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(114, 90, 166, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(114, 90, 166, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(114, 90, 166, 1)',
          pointHoverBorderColor: 'rgba(114, 90, 166, 1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 5,
          data: pReporting.granularity.map( item => item.conversionRate)
        }
      ]
    };
    this.setState({currentReport : {
      budgetLeft,
      totalSpent,
      totalDownloads: totalNewDownloads + totalReDownloads,
      avgCPA,
      conversionRate,
      cpaData,
      downLoadsData,
      budgetSpendData,
      conversionRateData,
      startTime: moment(pData.startTime),
      ttr
    }})

   

  }

  /**
   * to be redux saga 
   * @param {*} appId 
   * @param {*} country 
   */
  async getItunesStoreData( appId, country ){
    const API_PUBLIC_SEARCH =  'https://itunes.apple.com/lookup';
    try {
      const response = await axios.post(API_PUBLIC_SEARCH, {}, { params: { id : appId, 'Authorization' : 'Bear xsjsjsjsjkss',country} });
      console.log( '[getItunesStoreData] ', response.data.results); // error is not defined
      const results = response.data.results;
      if ( results.length > 0){
        return results[0];
      } else {
        return null;
      }
    } catch (error) {
      console.log( '[getItunesStoreData] ', error); // error is not defined
      return null;
    }
  }

  //to be redux saga
  async getSearchAdsData( appId ){
    const API_PUBLIC_SEARCH =  API_URL + '/searchads/public/search/'
    try {
      const response = await axios.get(API_PUBLIC_SEARCH, { params: { searchValue: appId} } );
      console.log( '[getSearchAdsData] ', response.data) 
      if ( response.data.length > 0){
        return response.data[0];
      } else {
        return null;
      }
    } catch (error) {
      return [];
      //no error for this api except network / timeout issue
      console.log( '[getSearchAdsData] ', error) 
    }
  }

  async getAppRecord(appId){
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    try {
      const response = await axios.get(`${API_URL}/user/campaigns/appid/${appId}`, { headers } )
      console.log( '[getAppRecord] ', response.data.response) 
      return response.data.response
    } catch (error) {
      //no error for this api except network / timeout issue
      console.log( '[getAppRecord] ', error) 
      return [];
    }
  }

  /**
   * 
   * @param {*} cid 
   */
  async getCampaignMetaData(cid){
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}

    this.setState({isCampaignRunning: false});
    try {
      const response = await axios.get(`${API_URL}/user/campaigns/cid/${cid}`, { headers } )
      console.log( '[getCampaignMetaData] ', cid,  response.data.response.data); 

      if (response.data.response.data.storefront == this.state.currentRegion.region) {
        this.setState({
          isCampaignRunning: response.data.response.data.servingStatus == "RUNNING"
        });
      }

      return response.data.response.data;
      // if ( data.reportingDataResponse.row[])
    } catch (error) {
      console.log( '[getCampaignMetaData] ', cid, error); 
      return null;
    }
  }
  /**
   * 
   * @param {*} cid campaign id in search ads 
   * @param {*} startDate string formateed YYYY-MM-DD
   * @param {*} endDate string formateed YYYY-MM-DD
   */
  async getCampaignReportingData(cid, startDate, endDate){
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    try {
      const responseTotal = await axios.get(`${API_URL}/user/campaigns/cid/${cid}/adgroups/rowtotals/${startDate}/${endDate}`, { headers } )
      // console.log( '[getCampaignData RowTotal] ', cid,  response.data.response.data); 
      const responseGranularity = await axios.get(`${API_URL}/user/campaigns/cid/${cid}/adgroups/granularity/${startDate}/${endDate}`, { headers } )
      // console.log( '[getCampaignData granularity] ', cid,  responseG.data.response.data); 

      if ( responseTotal.data.response.pagination.totalResults  > 0 ) {
        const totalData =responseTotal.data.response.data.reportingDataResponse.row[0].total;
        const granularity = responseGranularity.data.response.data.reportingDataResponse.row[0].granularity;
        console.log( '[getCampaignReportingData] ', cid,  totalData, granularity); 
        return {
          totalData,
          granularity
        };
      } else {
        return {
          totalData : null,
          granularity: []
        };
      }
      // if ( data.reportingDataResponse.row[])
    } catch (error) {
      console.log( '[getCampaignReportingData] ', cid, error); 
      return {
        totalData : null,
        granularity: []
      };
    }
  }

  translateCnName(region) {
    let customFlagLabels = {
      "US": "美国",
      "GB": "英国",
      "CA": "加拿大",
      "CH": "瑞士",
      "MX": "墨西哥",
      "ZH": "ZH",
      "AU": "澳大利亚",
      "NZ": "新西兰",
      "IT": "義大利",
      "FR": "法國",
      "DE": "德國",
      "ES": "西班牙",
      "JP": "日本",
      "KR": "韓國",
    };
    var CnName = customFlagLabels[region];
    if (!CnName || CnName.length <= 0) return region;
    return CnName;
  }

  render() {
    const { rowStyle, colStyle } = basicStyle;
    const { searchTerm , currentApp, secondApp, campaign} = this.props;    
    const { storeInfo, searchAdsInfo, currentRegion, appRecord, currentReport, isReportLoading } = this.state;

    const wisgetPageStyle = {
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'flex-start',
      padding: '15px',
      overflow: 'hidden',
      background: '#F3F3F3'
    };

    // const stackConfig = {
    //   ...rechartConfigs.StackedAreaChart,
    //   width: window.innerWidth < 450 ? 300 : 500
    // };

    const start = moment();
    const end = moment();

    const menuSubmenu = (
      // if ( process.env.REACT_APP_STAGE === 'fake'){
      <DropdownMenu onClick={(value) => this.onRegionSelected(value)}>
        <MenuItem key={"ALL"}>
          {"所有已投放國家"}
         </MenuItem>
         
        {searchAdsInfo && searchAdsInfo.storeFrontCountryCodes && searchAdsInfo.storeFrontCountryCodes.map(region=> {
          return (
            <MenuItem key={region}>
              <Flag style={{width:'36px'}}  code={ region } />
              {this.translateCnName(region)}
            </MenuItem>
          )
        })}
      </DropdownMenu>
    );
 
    return (
      <DashboardWrapper>
        {
          this.state.isReportLoading && (
            <OverlayLoading/>
          )
        }
      <style>{"\
        .ant-tooltip-content { position: relative; }\
        .ant-tooltip-inner {\
          padding: 18px;\
          padding-bottom: 21px;\
          background-color: rgba(0, 0, 0, .65);\
          line-height: 16px;\
          font-family: 'Montserrat';\
          font-size: 13px;\
          font-weight: 300;\
          color: rgba(255, 255, 255, 1);\
          letter-spacing: 0.04em;\
          border-radius: 10px;\
          text-shadow: 0 0 1px #555;\
        }\
        .ant-tooltip-placement-top .ant-tooltip-arrow {\
          position: absolute;\
          bottom: 0;\
          border-top-color: rgba(0, 0, 0, .4);\
          transform: translateY(100%);\
        }\
      "}</style>

        
        <div className="header">
        { process.env.REACT_APP_STAGE !== 'fake'  && 
          <dl className="app">
              <dt>
                <img src={ storeInfo ? storeInfo.artworkUrl100 : ''} alt="screen"/>
              </dt>

              <dd>
                <h1>{ storeInfo ? storeInfo.trackCensoredName : ''}</h1>
                <h2>
                  <span>
                    { storeInfo ? storeInfo.sellerName : ''}
                  </span>
                  <span>
                  {/* Started on { currentReport ? currentReport.startTime :  '' } */}
                  {
                    currentReport && currentReport.startTime && (
                      currentReport.startTime.format("于YYYY年MM月DD日 (dddd)开始")
                    )
                  }
                  </span>
                </h2>
              </dd>
            </dl>
          }

          { process.env.REACT_APP_STAGE === 'fake'    && 
          <dl className="app">
              <dt>
                <img src={ currentApp.artworkUrl100} alt="screen"/>
              </dt>

              <dd>
                <h1>{ currentApp.trackCensoredName }</h1>
                <h2>
                  <span>
                    { currentApp.sellerName }
                  </span>
                  <span>
                    Started on { currentReport ? currentReport.startTime :  "Tue, Jan 24, 2018" }
                  </span>
                </h2>
              </dd>
            </dl>
          }
          
          <button className="round-border-wrapper" onClick={ this.handleAddCampClick }>
            <div className="emulate-plus"></div>
            <p>添加广告项目</p>
          </button>

          <div className="header-controls">
            <dl className="budget-left">
              <dt>余额</dt>
              <dd>{ currentReport ? '$ ' + currentReport.budgetLeft  : '$ --'}</dd>
            </dl>

            <button
              className="round-border-wrapper add-budget"
              onClick={ () => { this.onOpenAddBudgetModal(); } }
            >
              <div className="emulate-plus"></div>
              <span>$</span>
              <p>增加预算</p>
            </button>

            <button
              className="round-border-wrapper campaign-state"
              onClick={ () => { this.changeCampaignState(!this.state.isCampaignRunning); } }
            >
              <img src={this.state.isCampaignRunning && RunningIcon || PauseIcon}/>
              <p>
                {this.state.isCampaignRunning && "运行中" || "已暂停"}
              </p>
            </button>

            <button className="round-border-wrapper refresh" onClick={ () => { this.updateResult(true, null); } }>
              <img src={RefreshIcon}/>
              <p>刷新</p>
            </button>
          </div>
          { !isReportLoading &&
            <AddBudgetModal
              defaultBudget={1000.00}
              budgetLeft={currentReport ?  currentReport.budgetLeft : 259.54}
              defaultRegion= {currentRegion ? currentRegion.region : 'US'}
              storeFrontCountryCodes={searchAdsInfo ? searchAdsInfo.storeFrontCountryCodes : []}
              onBudgetComfirmed={this.onBudgetComfirmed}
              isOpened={this.state.isShowBudgetModal}
              onClose={ () => {this.onCloseAddBudgetModal(); } }
            />
           }

           { this.state.addBudgetData &&
            <Modal
              open={this.state.isShowCheckoutModal}
              onClose={ () => {this.onCloseCheckoutModal(); }}
              center
              classNames={{ modal: 'checkout-modal' }}>
          
              <div>
                <h2> Appid : { this.state.addBudgetData.appId}</h2>
                <h3> region : { this.state.addBudgetData.region}</h3>
                <h3> budget : USD { this.state.addBudgetData.budget}</h3>

              </div>
              <div className="card-info">
                <StripeProvider  stripe={this.state.stripe}>
                  <Elements>
                      <CheckoutForm 
                        fontSize={'18px'} 
                        updateResult= {this.updateResult.bind(this) }
                        updateError= {this.updateError.bind(this) }
                        campaign={ this.state.campaign }
                        currentApp= { currentApp }
                        auth={ this.props.auth }
                        profile= { this.state.profile }
                        addBudgetData= {this.state.addBudgetData}
                      />
                  </Elements>
                </StripeProvider>
              </div>  
            </Modal>
          }
          

          
        </div>
        
        <div style={wisgetPageStyle} className="main">
          <Row style={rowStyle} gutter={0} justify="start">
                <Col sm={24} xs={24} md={16} lg={18} xl={18} style={colStyle} className="charts">


                    <Row style={rowStyle} gutter={0} justify="start">
                      <Col md={24} sm={24} xs={24} style={colStyle} className="charts">
                        <div className="chart-controls">
                          <div className="round-border-wrapper countries">
                            {/* <Tooltip placement="bottom" title={"Select the country to view data."}><span className="dashboard-tooltip">?</span></Tooltip> */}
                            <Dropdown overlay={menuSubmenu}>
                              <p>
                                <a className="ant-dropdown-link">
                                { currentRegion ? (<span><Flag style={{width:'36px'}}  code={ currentRegion.region } /><span>{this.translateCnName(currentRegion.region)}</span></span>) : "全部已投放国家"}
                                </a>
                              </p>
                            </Dropdown>
                            {/* <CountryDropDown
                              user={"fdfd"}
                            /> */}
                          </div>
                          
                          <div className="round-border-wrapper date-range">
                            {/* <Tooltip placement="bottom" title={"Select the date range to view data."}><span className="dashboard-tooltip">?</span></Tooltip> */}
                            <p>
                              <img src={CalendarIcon}/>
                              {
                                this.state.startDate && this.state.endDate && (
                                  moment(this.state.startDate).format('YYYY-MM-DD') + '->' + moment(this.state.endDate).format('YYYY-MM-DD')
                                )
                              }
                            </p>
                            <div className="isoCalendarDatePicker">
                              <DateRangePicker
                                lang={'zh-cn'}
                                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                                startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                onDatesChange={this.onDatesChange}
                                onFocusChange={this.onFocusChange}
                                isOutsideRange={() => false}  
                              />
                            </div>
                          </div>
                          
                          <ExcelFile element={
                            <button className="round-border-wrapper download">
                            {/* <Tooltip placement="bottom" title={"Export data as a CSV file."}><span className="dashboard-tooltip">?</span></Tooltip> */}
                              <img src={DownloadIcon}/>
                              <p>下载数据报告</p>
                            </button>
                          }>
                              <ExcelSheet data={downLoadsData.datasets[0].data.map((v)=>({value:v}))} name="Dashboard CSV data">
                                {
                                  downLoadsData.labels.map((label, index)=> {
                                    return <ExcelColumn label={label} value="value"/>
                                  })
                                }
                              </ExcelSheet>
                          </ExcelFile>
                        </div>
                        </Col>
                    </Row>
                    <Row style={rowStyle} gutter={16} justify="start">
                      <Col sm={24} xs={24} md={12} lg={12} xl={6} style={colStyle} >
                        <div className="responsiveBlock">
                          <SaleWidget
                            top='#47B2AA'
                            price={ currentReport ? currentReport.totalDownloads : "--"}
                            details={"下载量"}
                            fontColor="#403739"
                            tooltipTitle="Number of users who downloaded the app."
                            tooltip={<span className={"dashboard-tooltip"}>?</span>}
                            tooltipPlacement="bottom"
                          />
                        </div>
                        </Col>
                        <Col  sm={24} xs={24} md={12} lg={12} xl={6} style={colStyle} >
 
                        <div className="responsiveBlock">

                          <SaleWidget
                          top='rgba(93, 215, 255, 1)'
                            price={currentReport ? "$ " + currentReport.avgCPA.toFixed(2) :"$ --"}
                            details={"获客成本"}
                            fontColor="#403739"
                            tooltipTitle="The average amount of budget paid to acquire a single install."
                            tooltip={<span className={"dashboard-tooltip"}>?</span>}
                            tooltipPlacement="bottom"
                          />
                        </div>
                        </Col>
                        <Col sm={24} xs={24} md={12} lg={12} xl={6} style={colStyle} >
 
                        <div className="responsiveBlock">
                          <SaleWidget
                          top='rgba(235, 183, 99, 1)'
                            price={ currentReport ? "$ "+ currentReport.totalSpent.toFixed(2) : "$ --"}
                            details={ "预算消耗"}
                            fontColor="#403739"
                            tooltipTitle="Total amount of budget spent."
                            tooltip={<span className={"dashboard-tooltip"}>?</span>}
                            tooltipPlacement="bottom"
                          />
                        </div>
                        </Col>
                        <Col  sm={24} xs={24} md={12} lg={12} xl={6} style={colStyle} >
 
                        <div className="responsiveBlock">
                          <SaleWidget
                            price={currentReport ? currentReport.conversionRate * 100 +"%" : "--%"}
                            details={"转化率"}
                            fontColor="#403739"
                            tooltipTitle="Percentage of users who downloaded the app out of total number of visitors who arrived at the App Store page."
                            tooltip={<span className={"dashboard-tooltip"}>?</span>}
                            tooltipPlacement="bottom"
                          />
                        </div>
                        </Col>
                    </Row>

                    <Row style={rowStyle} gutter={16} justify="start">
                     <Col md={24} sm={24} xs={24} style={colStyle} className="charts">
                        <Box>
                          <ContentHolder>
                            <Tabs
                              defaultActiveKey="1"
                              renderTabBar={() =>
                                <ScrollableInkTabBar
                                  pageSize={4}
                                  speed={5}
                                />}
                              renderTabContent={()=><TabContent />}
                            >
                              <TabPane tab='下载量' key="1">
                                <Line data={ currentReport ? currentReport.downLoadsData :downLoadsData} options={{maintainAspectRatio: false}}/>
                              </TabPane>

                              <TabPane tab='获客成本' key="2">
                                <Line data={ currentReport ? currentReport.cpaData : cpaData} options={{maintainAspectRatio: false}}/>
                              </TabPane>

                              <TabPane tab='预算消耗' key="3">
                                <Line data={ currentReport ? currentReport.budgetSpendData : budgetSpendData} options={{maintainAspectRatio: false}}/>
                              </TabPane>

                              <TabPane tab='转化率' key="4">
                                <Line data={ currentReport ? currentReport.conversionRateData : conversionRateData} options={{maintainAspectRatio: false}}/>
                              </TabPane>
                            </Tabs>
                          </ContentHolder>
                        </Box>
                      </Col>
                    </Row>
              </Col>
              <Col  sm={24} xs={24} md={8} lg={6} xl={6} style={colStyle} className="iphone-container">
                  <ContentHolder>
                    { process.env.REACT_APP_STAGE === 'fake' && currentApp && secondApp && searchTerm &&
                     <AdPreview
                     currentApp={ currentApp }
                     secondApp={ secondApp }
                     searchTerm={ searchTerm }
                   />
                    }
                    { process.env.REACT_APP_STAGE !== 'fake'  && storeInfo &&
                      <AdPreview
                     currentApp={ storeInfo }
                     secondApp={ storeInfo }
                     searchTerm={ 'search' }
                     />
                    }
                     
                  </ContentHolder>
              </Col>
            {/* Create the big chart here with drop down list instead of tab for mobile view */}
          </Row>

        


          <Row style={rowStyle} gutter={0} justify="start">
            <Col md={8} sm={24} xs={24} style={colStyle} className="tap-through-container">
              <IsoWidgetsWrapper>
                {/* Chart */}
                <Box title="">
                  <ContentHolder>
                    <div style={{ padding:'46px 38px'}}>
                      <label style={{ 'paddingBottom': '14px'}}>
                        点击转化率
                        <Tooltip title={"Percentage of number of users who tap through to arrive at the App Store page out of total number of users who viewed the ad."}><span className="dashboard-tooltip">?</span></Tooltip>
                      </label>

                      <div>                  
                        {/* <CircularProgressbar className='tap-through-chart' percentage={ currentReport ? ( currentReport.ttr * 100 ).toFixed(1)  : 27} /> */}
                        <CircularProgressBar
                          arcWidth={130}
                          arcData={[
                              { percentage: 1, strokeColor: "#cfc9de" }
                          ]}
                          strokeWidth={8}
                          strokeColor="rgba(114, 92, 164, 1)"
                          percentage={currentReport ? ( currentReport.ttr * 100 ).toFixed(1) : "0.0"}
                          textData={{
                            fontColor: "rgba(114, 92, 164, 1)",
                            fontSize: "35px"
                          }}
                        />
                      </div>

                      <div style={{ display: 'block', 'paddingTop': '14px', 'textAlign': 'center' }}>   
                        <ButtonAction
                          onClick={this.goToAso}
                          style={{ margin: '0 auto'}}
                        >
                          ASO优化
                        </ButtonAction>
                      </div>
                    </div>
                  </ContentHolder>
                </Box>
              </IsoWidgetsWrapper>
            </Col>
            
            <Col md={16} sm={24} xs={24} style={colStyle} className="tracking-accounts">
              <IsoWidgetsWrapper>
                {/* Chart */}
                <IsoWidgetBox height={300}>
                <ContentHolder>
                    <div className="firstLine">投资回报率 (ROI) <Tooltip title={"Profitability ratio of total revenue to total budget spent."}><span className="dashboard-tooltip">?</span></Tooltip><br /><br /></div>

                    <div className="secondLine">连接你的监测平台帐户获得投资回报率数据</div>

                    <div className="thirdLine">
                    <Row style={rowStyle} gutter={0} justify="start">
                          <Col md={4} sm={24} xs={24}></Col>
                          <Col md={8} sm={24} xs={24} className="acc-flyer">
                          <img className="trackingAccount" src={process.env.PUBLIC_URL + appsflyer} />

                          </Col>
                          <Col md={8} sm={24} xs={24} className="acc-adjust">
                          <img className="trackingAccount" src={process.env.PUBLIC_URL + adjust} />

                          </Col>
                          <Col md={4} sm={24} xs={24}></Col>

                          <Col md={4} sm={24} xs={24}></Col>
                          <Col md={8} sm={24} xs={24} className="acc-tune">
                          <img className="trackingAccount" src={process.env.PUBLIC_URL + tune} />
                          
                          </Col>
                          <Col md={8} sm={24} xs={24} className="acc-kochava">
                          <img className="trackingAccount" src={process.env.PUBLIC_URL + kochava} />
                          </Col>
                          <Col md={4} sm={24} xs={24}></Col>
                    </Row>


                    </div>
                  </ContentHolder>
                </IsoWidgetBox>
              </IsoWidgetsWrapper>
            </Col>
          </Row>

        
        
        </div>
       
      </DashboardWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { 
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch) ,

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth0SignUp: state.get('deep').auth0SignUp,
    auth0SignIn: state.get('deep').auth0SignIn,
    campaign: state.get('campaign'),
    isLoggedIn: false,//state.Auth.get('idToken') !== null ? true : false,
    currentApp: state.getIn( ['ItunesSearch', 'currentApp']),
    secondApp: state.getIn( ['ItunesSearch', 'secondApp']),
    searchTerm: state.getIn( ['ItunesSearch', 'searchTerm']),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js